"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableCell = exports.DashedDiv = void 0;
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var TableCell_1 = __importDefault(require("@mui/material/TableCell"));
exports.DashedDiv = (0, styles_1.styled)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        padding: theme.spacing(2),
        background: 'rgba(237, 241, 243, 0.25)',
        border: "1px dashed ".concat((_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.contrastText),
        borderRadius: 10,
    });
});
exports.StyledTableCell = (0, styles_1.styled)(TableCell_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        border: 0,
        padding: theme.spacing(0.75, 0),
    });
});
